/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Milestone = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z" }],
    ["path", { d: "M12 13v8" }],
    ["path", { d: "M12 3v3" }]
  ]
];

export { Milestone as default };
//# sourceMappingURL=milestone.js.map
